var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-close",
    points: "0 0 23.9995 0 23.9995 24 0 24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "InformationBar/PC",
    transform: "translate(-1360.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/common/close-circle",
    transform: "translate(1360.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-close",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-close"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1375,16.195 C17.2585,16.316 17.3335,16.483 17.3335,16.667 C17.3335,17.035 17.0345,17.333 16.6665,17.333 C16.4825,17.333 16.3165,17.258 16.1955,17.138 L11.9995,12.943 L7.8055,17.137 C7.6845,17.258 7.5185,17.333 7.3335,17.333 C6.9645,17.333 6.6665,17.035 6.6665,16.667 C6.6665,16.483 6.7415,16.316 6.8625,16.195 L6.8625,16.195 L11.0575,12 L6.8625,7.805 C6.7415,7.684 6.6665,7.517 6.6665,7.333 C6.6665,6.965 6.9645,6.667 7.3335,6.667 C7.5175,6.667 7.6845,6.741 7.8055,6.862 L11.9995,11.057 L16.1955,6.862 C16.3165,6.741 16.4825,6.667 16.6665,6.667 C17.0345,6.667 17.3335,6.965 17.3335,7.333 C17.3335,7.518 17.2585,7.684 17.1375,7.805 L12.9435,12 L17.1375,16.195 Z M11.9995,0 C5.3725,0 -0.0005,5.373 -0.0005,12 C-0.0005,18.628 5.3725,24 11.9995,24 C18.6275,24 23.9995,18.628 23.9995,12 C23.9995,5.373 18.6275,0 11.9995,0 L11.9995,0 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-close)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f59aceebe705aa4f7232a1a4562f565d.svg";
export { ForwardRef as ReactComponent };